<template>
  <div class="properties-centent kk-checkbox">
    <div class="properties-body">
      <a-empty
        class="hint-box"
        v-show="selectForm.id === ''"
        description="请先选择表单"
      />

      <a-form v-show="selectForm.id !== ''">
        <a-form-item hidden class="ant-form-item-vertical" v-if="isDefined(selectForm.name)" label="表单显隐">
          <ASwitch />
        </a-form-item>
        <a-form-item hidden class="ant-form-item-vertical" v-if="isDefined(selectForm.name)" label="显示逻辑">
          <a @click="formVisiableModel()">点击设置</a>
        </a-form-item>
        <a-form-item v-if="isDefined(selectForm.name)" label="表单名称">
          <Input v-model="selectForm.name" readonly />
        </a-form-item>
        <a-form-item v-if="isDefined(selectForm.nameEn) && kDesignType === 'PROJECT_FORM'" label="英文名称">
          <Input v-model="selectForm.nameEn" readonly />
        </a-form-item>
        <a-form-item v-if="isDefined(selectForm.scale) && (kDesignType === 'CONFIG_FORM' || kDesignType === 'SCHEMA_DESIGN')" label="表单类型">
          <Select
            v-model="selectForm.scale"
            :options="formTypeOptions"
            :allowClear="true"
          />
        </a-form-item>
        <a-form-item v-if="isDefined(selectForm.type) && kDesignType === 'PROJECT_FORM'" label="表单类型">
          <Select
            v-model="selectForm.type"
            :options="projectFormTypeOptions"
            :allowClear="true"
          />
        </a-form-item>
        <a-form-item v-if="isDefined(selectForm.intro) && (kDesignType === 'CONFIG_FORM' || kDesignType === 'SCHEMA_DESIGN')" label="表单说明">
          <Textarea v-model="selectForm.intro"/>
        </a-form-item>
        <a-form-item v-if="isDefined(selectForm.description) && kDesignType === 'PROJECT_FORM'" label="表单说明">
          <Textarea v-model="selectForm.description"/>
        </a-form-item>
        <a-form-item v-if="isDefined(selectForm.inputTip)" label="填写提示">
          <Textarea v-model="selectForm.inputTip"/>
        </a-form-item>
        <a-form-item v-if="isDefined(selectForm.testType)" label="测评方式">
          <Select
            v-model="selectForm.testType"
            :options="evaluationTypeOptions"
            :allowClear="true"
          />
        </a-form-item>
        <a-form-item class="ant-form-item-vertical" v-if="isDefined(selectForm.unnecessary) && kDesignType === 'PROJECT_FORM'" label="是否选填">
          <a-switch checkedChildren="是" unCheckedChildren="否" v-model="unnecessary" @change="onSwitchChange" />
        </a-form-item>
        <a-form-item v-if="selectForm.unnecessary === 1 && kDesignType === 'PROJECT_FORM'" label="选填中心">
          <a-select placeholder="请选择选填中心" v-model="selectForm.centerIdList" mode="multiple" @change="centerChange">
            <a-select-option :value="item.id" v-for="item in centerList">{{ item.name }}</a-select-option>
          </a-select>
        </a-form-item>
        <!-- <a-tooltip placement="topLeft" style="padding-right:2px;" title="勾选后将按上述选填规则，生效已收集的受试者表单填写规则"> -->
          <a-form-item class="ant-form-item-vertical" v-if="selectForm.unnecessary === 1 && kDesignType === 'PROJECT_FORM'" label="受试者表单选填">
            <a-checkbox v-model="selectForm.applyAllPatient"></a-checkbox>
          </a-form-item>
        <!-- </a-tooltip> -->
        <a-form-item class="ant-form-item-vertical" v-if="isDefined(selectForm.name) && kDesignType === 'PROJECT_FORM'" label="表单停用">
          <ASwitch v-model="disableStatus" @change="handleStatusChange" />
        </a-form-item>
        <a-form-item>
          <!--
          <a-button @click="handleFormModal('BASE','基本属性')" type="primary" style="margin-left: 8px">基本属性</a-button>
          -->
          <a-button v-if="kDesignType === 'CONFIG_FORM' || kDesignType === 'SCHEMA_DESIGN'" @click="handleFormModal('EXTEND','扩展属性')" type="primary" style="margin-left: 8px">扩展属性</a-button>
          <a-button v-if="kDesignType === 'CONFIG_FORM' || kDesignType === 'SCHEMA_DESIGN'" @click="handleFormModal('ANNEX','表单附件')" type="primary" style="margin-left: 8px">表单附件</a-button>
          <a-button v-if="kDesignType === 'CONFIG_FORM' || kDesignType === 'SCHEMA_DESIGN'" @click="handleFormGroup()" type="primary" style="margin-left: 8px">表单归类</a-button>
          <a-button @click="historyHandle" type="primary" style="margin-left: 8px">历史版本</a-button>
          <a-button @click="formPreviewHandle" type="primary" style="margin-left: 8px">表单预览</a-button>
          <a-button v-if="kDesignType === 'CONFIG_FORM' || kDesignType === 'SCHEMA_DESIGN'" @click="handleAuditModal()" type="primary" style="margin-left: 8px;">表单审核</a-button>
        </a-form-item>
      </a-form>
    </div>
    <csim-config-form-modal ref="csimConfigFormModal" @ok="modalFormOk" :selectForm="selectForm" @reloadSelectForm="reloadSelectForm" @reloadFormList="reloadFormList"></csim-config-form-modal>
    <csim-config-form-visible-modal ref="csimConfigFormVisiableModal" @ok="modalFormVisiableOk" :selectForm="selectForm"></csim-config-form-visible-modal>
    <temp-config-form-group ref="formGroup"></temp-config-form-group>

    <a-modal :title="auditTitle" :width="600" :visible="auditVisible" @ok="handleAudit" @cancel="handleAuditCancel" cancelText="取消">
      <div>
        <span>{{ auditDescription }}</span>
      </div>  
      <Radio :options="auditOptions" v-model="auditStatus" @change="onAuditChange"/>
    </a-modal>

    <a-drawer
      title="CRF表单预览"
      width="60%"
      :closable="false"
      @close="onPreviewClose"
      :visible="formPreviewVisible"
      
    >
      <div style="font-size: 18px;font-weight: bold;text-align: center;margin-bottom: 10px">
        {{currentForm.name}}
      </div>
      <base-form-view ref="baseFormView" :base-data="currentForm" :is-view="true" @formChange="formChange"></base-form-view>

      <div style="text-align: right;margin-top: 20px">
        <a-button @click="onPreviewClose" style="margin-left: 20px">关闭</a-button>
      </div>
    </a-drawer>

    <a-drawer
      title="CRF表单预览"
      width="60%"
      :closable="false"
      @close="onPreviewClose"
      :visible="projectPreviewVisible"
    >
      <div style="font-size: 18px;font-weight: bold;text-align: center;margin-bottom: 10px">
        {{currentForm.name}}
      </div>
      <form-view :base-data="currentForm">

      </form-view>

      <div style="text-align: right;margin-top: 20px">
        <a-button @click="onPreviewClose" style="margin-left: 20px">关闭</a-button>
      </div>
    </a-drawer>

    <a-modal
      title="历史版本"
      :width="600"
      :visible="historyVisible"
      switchFullscreen
      :footer="null"
      @cancel="historyVisible=false">
      <div class="history-div" v-for="(item,index) in historyList" :key="index">
        <div>
          <label class="title">
            历史创建时间：
          </label>
          <label class="time">
            {{item.historyCreateTime}}
          </label>
          <a-button class="btn" size="small" type="primary" @click="historyView(item)">查看</a-button>
          <a-button style="margin-left: 10px;" class="btn" size="small" type="primary" @click="historyRevert(item)">恢复</a-button>
        </div>
        <div class="description">

        </div>
      </div>
    </a-modal>
    <a-drawer
      title="预览"
      width="60%"
      :closable="false"
      @close="onViewHistoryClose"
      :visible="viewHistoryVisible"
    >
      <div style="font-size: 18px;font-weight: bold;text-align: center;margin-bottom: 10px">
        {{current.name}}
      </div>
      <form-view :base-data="current">

      </form-view>
      <div style="text-align: right;margin-top: 20px">
        <a-button @click="onViewHistoryClose" style="margin-left: 20px">关闭</a-button>
      </div>
    </a-drawer>
  </div>
</template>
<script>

import { putAction, getAction, postAction } from '@/api/manage'
import { JeecgListMixin } from '@/mixins/JeecgListMixin'
import kCheckbox from "../../KCheckbox/index.vue";
import { pluginManager } from "../../../utils/index";
import CsimConfigFormModal from '@views/tempconfig/formDesign/csim/CsimConfigFormModal'
import CsimConfigFormVisibleModal from '@views/tempconfig/formDesign/csim/CsimConfigFormVisibleModal'
import TempConfigFormGroup from '@views/tempconfig/form/TempConfigFormGroup.vue'
import BaseFormView from '@comp/form/BaseFormView.vue'
import FormView from '@views/project/components/FormView'

const InputNumber = pluginManager.getComponent("number").component;
const Input = pluginManager.getComponent("input").component;
const Radio = pluginManager.getComponent("radio").component;
const RadioButton = pluginManager.getComponent("radioButton").component;
const Textarea = pluginManager.getComponent("textarea").component;
const Slider = pluginManager.getComponent("aSlider").component;
const ASwitch = pluginManager.getComponent("switch").component;
const Select = pluginManager.getComponent("select").component;

export default {
  name: "csimFormProperties",
  components: {
    kCheckbox,
    InputNumber,
    Input,
    Radio,
    RadioButton,
    Textarea,
    Slider,
    ASwitch,
    Select,
    CsimConfigFormModal,
    CsimConfigFormVisibleModal,
    TempConfigFormGroup,
    BaseFormView,
    FormView,
  },
  data() {
    return {
      disableMixinCreated: true,
      auditTitle: "表单审核",
      auditDescription: "",
      auditVisible: false,
      formTypeOptions: [
        {
          "value": "1",
          "label": "量表"
        },
        {
          "value": "0",
          "label": "表单"
        }
      ],
      projectFormTypeOptions: [
        {
          "value": "1",
          "label": "表单"
        },
        {
          "value": "2",
          "label": "量表"
        }
      ],
      evaluationTypeOptions: [
        {
          "value": "0",
          "label": "自评"
        },
        {
          "value": "1",
          "label": "他评"
        },
        {
          "value": "2",
          "label": "均可"
        }
      ],
      auditOptions: [
        {
          "value": "0",
          "label": "取消审核"
        },
        {
          "value": "1",
          "label": "审核完成"
        }
      ],
      auditStatus: "",

      formPreviewVisible:false,
      projectPreviewVisible:false,
      currentForm: {},
      centerList: [],
      unnecessary: false,
      historyList:[],
      historyVisible: false,
      viewHistoryVisible:false,
      current:{},
      disableStatus: false,
    }
  },
  mixins: [JeecgListMixin],
  created() {
    console.log("Form Properties: " + this.kDesignType);
    if (this.kDesignType === 'PROJECT_FORM' || this.kDesignType === 'SCHEMA_DESIGN') {
      let centerIdList = []
      if (this.selectForm.optionCenterIds) {
        centerIdList = this.selectForm.optionCenterIds.split(',')
      }

      this.selectForm.centerIdList = centerIdList;

      this.initFormProperty();

      this.initcenter();
    }
  },
  computed: {
    options() {
      return this.selectItem.options || {};
    }
  },
  props: {
    selectItem: {
      type: Object,
      required: false
    },
    selectForm: {
      type: Object,
      required: true
    },
    hideModel: {
      type: Boolean,
      default: false
    },
    hideTypeModel: {
      type: Boolean,
      default: false
    },
    kDesignType:{
      type:String,
      default:''
    },
    projectId:{
      type:String,
      default:''
    },
  },
  methods: {
    initFormProperty() {
      if (this.kDesignType === 'PROJECT_FORM' || this.kDesignType === 'SCHEMA_DESIGN') {
        this.unnecessary = this.selectForm.unnecessary === 1 ? true : false;
        this.disableStatus = this.selectForm.status === '0' ? true : false;
      }
    },

    handleChangeCol(e) {
      console.log(e);
    },

    handleFormModal: function (formType, title) {
      this.$refs.csimConfigFormModal.edit(this.selectForm);
      this.$refs.csimConfigFormModal.formType = formType;
      this.$refs.csimConfigFormModal.disableSubmit = false;
      this.$refs.csimConfigFormModal.title = title;
    },

    formVisiableModel: function() {
      this.$refs.csimConfigFormVisiableModal.init();
      this.$refs.csimConfigFormVisiableModal.disableSubmit = false;
    },

    modalFormVisiableOk: function() {

    },

    reloadFormList(){
      this.$emit("reloadFormList");
    },

    handleFormGroup(){
      this.$refs.formGroup.view(this.selectForm)
    },

    handleAudit() {
      if (this.auditStatus === '1') {
        putAction('/tempconfig/tempConfigForm/audit?id='+this.selectForm.id).then(res=>{
          if(res.success){
            this.$message.success(res.message);
            this.auditVisible = false;
          }else{
            this.$message.error(res.message)
          }
        })
      } else if (this.auditStatus === '0') {
        putAction('/tempconfig/tempConfigForm/unaudit?id='+this.selectForm.id).then(res=>{
          if(res.success){
            this.$message.success(res.message);
            this.auditVisible = false;
          }else{
            this.$message.error(res.message)
          }
        })
      }

      this.$emit("reloadSelectForm");
    },

    reloadSelectForm(func) {
      this.$emit("reloadSelectForm", func);
    },

    handleAuditModal() {
      this.auditVisible = true;
      this.auditDescription = `请选择表单【${this.selectForm.name}】审核状态。`;

      if ((this.selectForm.status&16)==16) {
        this.auditStatus = '0';
      } else {
        this.auditStatus = '1';
      }

      this.onAuditChange();
    },

    onAuditChange(){
      if (this.auditStatus === '1') {
        this.auditDescription = `您确定表单【${this.selectForm.name}】审核通过吗? 审核通过后表单将无法修改！`;
      } else if (this.auditStatus === '0') {
        this.auditDescription = `您确定将表单【${this.selectForm.name}】改为未审核吗?`;
      }
    },

    handleAuditCancel() {
      this.auditVisible = false;
    },

    isDefined(value) {
      return typeof value !== "undefined";
    },

    formPreviewHandle(){
      if (this.kDesignType === 'CONFIG_FORM' || this.kDesignType === 'SCHEMA_DESIGN') {
        getAction('/tempconfig/tempConfigForm/getInfoByCode',{code:this.selectForm.code}).then(res=>{
          if(res.success){
            this.currentForm = res.result
            this.formPreviewVisible = true
          }
        })
      } else if (this.kDesignType === 'PROJECT_FORM') {
        getAction('/project/projectForm/getInfoById',{id: this.selectForm.id}).then(res=>{
          if(res.success){
            this.currentForm = res.result
            this.projectPreviewVisible = true
          }
        })
      }
    },

    onPreviewClose(){
      this.formPreviewVisible = false;
      this.projectPreviewVisible = false;
    },

    formChange(formItem){
      if(this.$refs.baseFormView){
        const formData = this.$refs.baseFormView.getFormData()
        postAction('/tempconfig/tempConfigFormItem/cascade',{formId:this.currentForm.id,formItemId:formItem.id,itemForm:JSON.stringify(formData)}).then(res=>{
          if(res.success){
            if(res.result){
              for (let key in res.result){
                this.$refs.baseFormView.setFormData(key,res.result[key])
              }
            }
          }else{
            this.$message.error(res.message)
          }
        })
      }
    },
    initcenter() {
      getAction('/management/center/listAll', { status: '1' }).then(res => {
        if (res.success) {
          this.centerList = res.result
        } else {
          this.$message.error('后台请求异常')
        }
      })
    },
    centerChange(keys){
      const centerNameList = []
      this.centerList.forEach(item=>{
        for (let i = 0; i < keys.length; i++) {
          const key = keys[i]
          if(item.id==key){
            centerNameList.push(item.name)
            break
          }
        }
      })
      this.$set(this.selectForm,'centerNameList',centerNameList)
    },
    onSwitchChange(checked) {
      this.selectForm.unnecessary = checked ? 1 : 0
    },

    historyHandle(){
      if (this.kDesignType === 'PROJECT_FORM') {
        getAction('/project/projectForm/historyList',{id: this.selectForm.id}).then(res=>{
          if(res.success){
            this.historyList = res.result
            if(this.historyList.length){
              this.historyVisible = true
            }else{
              this.$message.warning('该表单当前没有历史版本')
            }
          }
        })
      } else if (this.kDesignType === 'CONFIG_FORM' || this.kDesignType === 'SCHEMA_DESIGN') {
        this.$message.error('该功能暂未实现。')
      }
    },
    historyView(record){
      this.viewHistory(record)
    },
    viewHistory(record){
      getAction('/project/projectForm/getInfoById',{id: record.id}).then(res=>{
        if(res.success){
          this.current = res.result
          this.viewHistoryVisible = true
        }
      })
    },
    onViewHistoryClose(){
      this.viewHistoryVisible = false
    },
    historyRevert(record) {
      this.$message.error('恢复历史功能暂未实现。')
    },
    handleStatusChange(checked) {
      let status;
      if (checked) {
        status = '0';
      } else {
        status = '1';
      }

      postAction('/project/projectForm/editStatus',{id: this.selectForm.id, status:status}).then(res=>{
        if(!res.success){
          this.$message.warning(res.message)
        }

        this.reloadSelectForm(this.initFormProperty);
      })
    }
  }
};
</script>
<style lang="less" scoped>
  .ant-form-item-vertical {
    display: flex;
    /deep/.ant-form-item-label {
      align-content: center;
    }
  }
  .history-div{
    margin: 0px 20px 20px 20px;
    text-align: center;
    .title{

    }
    .time{
      color: @primary-color;
      margin: 0px 20px;
    }
    .btn{

    }
  }
</style>
